<meta name="viewport" content="width=device-width, initial-scale=1.0">
<svg height="20" width="100%"  preserveAspectRatio="xMinYMin meet">
  <text #cptitle class="cp-font-bold"
        x="0" y="15" fill="#277099" style="font-size: 12px; text-align: left"></text>
</svg>
<svg class="po-xl-12 po-lg-12 po-md-12 po-sm-12" width="100%" height="20"
preserveAspectRatio="xMinYMin meet">

  <rect x="4" y="4" rx="4" ry="4" width="98%" height="10"
    style="fill:#ccc;stroke-width:0;stroke:#FFFFFF;opacity:1;" />
  <rect x="4" y="4" rx="4" ry="4" [style.width.%]="percentInfo" height="10"
    style="fill:#277099;stroke-width:0;stroke:#FFFFFF;" />

</svg>
<svg height="20" width="100%"   preserveAspectRatio="xMinYMin meet">
  <text #cpinfo class="cp-font-bold cp-font-blue" x="0" y="15" fill="#277099">{{infodescription}}</text>
  <text class="cp-font-bold cp-font-blue" x="80%" y="15" fill="#435357"
    *ngIf="showTextDescription">{{textdescription}}</text>
</svg>
